import React from 'react';
import ContactBanner from '../components/contact-banner';
import Navbar from '../components/Home-navbar';
import './home.scss';
import KometsBanner from '../components/komets-banner';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

function Home() {
  const description = "BC Surface Supply is your premier source for cabinets, countertops, and flooring in Fort Wayne, Indiana. We provide turn-key finish packages to fit any style and budget.";
  const keywords = "kitchen cabinets, bathroom cabinets, countertops, flooring, Fort Wayne, Indiana, home improvement, contractor supplies";

  return (
    <div className='App'>
      <SEO 
        title="Home"
        description={description}
        keywords={keywords}
        canonicalUrl="https://bcsupply.com"
        ogImage="/assets/box-cabinets.jpg"
      />
      <StructuredData 
        type="HomePage"
        name="BC Supply Home"
        description={description}
      />
      <header>
        <Navbar />
      </header>
      <div>
        <div className='container'>
          <div className='home-intro'>
            <p>BC Surface Supply is the contractor's go-to source for cabinets, countertops and flooring., providing turn-key finish packages to fit any style and budget.
              <br/>We offer multiple cabinet lines, with numerous styles and features that will meet any taste and design. <br/>Looking for granite or quartz countertops? We have a state-of-the-art fabrication shop.<br/>
              <br/>With a full-line of flooring products, the professionals at BC will help you find the right option to make your floors look great.</p>
            <br/>
          </div>
          <h2>Specializing in:</h2>

          <div className='callout-boxes'>
            <a href="cabinets" className='box'>
              <div className='image'>
                <img src="../assets/box-cabinets.jpg" alt="View our Cabinet selections" />
              </div>
              <div className='description'>
                Cabinets
              </div>
            </a>

            <a href="countertops" className='box'>
              <div className='image'>
                <img src="../assets/box-countertops.jpg" alt="View our Countertop selections" />
              </div>
              <div className='description'>
                Countertops
              </div>
            </a>

            <a href="sinks" className='box'>
              <div className='image'>
                <img src="../assets/box-sinks.jpg" alt="View our Sink selections" />
              </div>
              <div className='description'>
                Sinks
              </div>
            </a>
          </div>

          <ContactBanner></ContactBanner>
        </div>
      </div>
      <KometsBanner></KometsBanner>
    </div>
  );
}

export default Home;